 const TimeZones = [
  { label: 'Hawaii Time Zone', value: 'Hawaii', zone: 'Pacific/Honolulu' },
  { label: 'Pacific Time Zone', value: 'Pacific', zone: 'America/Los_Angeles' },
  { label: 'Mountain Time Zone', value: 'Mountain', zone: 'America/Denver' },
  { label: 'Arizona Time Zone', value: 'Arizona', zone: 'America/Phoenix' },
  { label: 'Central Time Zone', value: 'Central', zone: 'America/Chicago' },
  { label: 'Eastern Time Zone', value: 'Eastern', zone: 'America/New_York' },
];

export default TimeZones;


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/Timezones.js